import React from 'react';

import { WebUrlType } from '@api/v3';
import Typography from '@components/Typography';
import {
  HotelTitle,
  HotelTitleMobile,
} from '@components/views/hotel/detail/HotelDetailStyle';
import { useDevice } from '@contexts/device';
import { getHotelSearchURLType } from '@components/views/hotel/utils';
import { HOTEL_SEARCH_TYPES } from '@constants/constants';
interface HotelNameProps {
  actionPageLocationType: WebUrlType;
  actionPageLocationLabel: string;
}

const HotelListingTitle = ({
  actionPageLocationType,
  actionPageLocationLabel,
}: HotelNameProps) => {
  const { isDesktop } = useDevice();
  return isDesktop ? (
    <>
      {actionPageLocationType === WebUrlType.HOTEL_CHAIN ||
      actionPageLocationType === WebUrlType.HOTEL_THEME ? (
        <HotelTitle>
          <Typography variant='Title5' weight='SemiBold'>
            {actionPageLocationLabel}
          </Typography>
        </HotelTitle>
      ) : actionPageLocationType === WebUrlType.HOTEL_REGION ||
        actionPageLocationType === WebUrlType.HOTEL_CITY ? (
        <HotelTitle>
          <Typography variant='Title5' weight='SemiBold'>
            {`${actionPageLocationLabel} Otelleri`}
          </Typography>
        </HotelTitle>
      ) : getHotelSearchURLType(actionPageLocationType ?? '') ===
        HOTEL_SEARCH_TYPES.HOTEL_LISTING ? (
        <HotelTitle>
          <Typography variant='Title5' weight='SemiBold'>
            {`${actionPageLocationLabel} Otelleri`}
          </Typography>
        </HotelTitle>
      ) : (
        <HotelTitle>
          <Typography variant='Title5' weight='SemiBold'>
            {actionPageLocationLabel}
          </Typography>
        </HotelTitle>
      )}
    </>
  ) : (
    <>
      {actionPageLocationType ? (
        <>
          {actionPageLocationType === WebUrlType.HOTEL_CHAIN ||
          actionPageLocationType === WebUrlType.HOTEL_THEME ? (
            <HotelTitleMobile>
              <Typography variant='caption' weight='SemiBold'>
                {actionPageLocationLabel}
              </Typography>
            </HotelTitleMobile>
          ) : actionPageLocationType === WebUrlType.HOTEL_REGION ||
            actionPageLocationType === WebUrlType.HOTEL_CITY ? (
            <HotelTitleMobile>
              <Typography variant='caption' weight='SemiBold'>
                {`${actionPageLocationLabel} Otelleri`}
              </Typography>
            </HotelTitleMobile>
          ) : getHotelSearchURLType(actionPageLocationType ?? '') ===
            HOTEL_SEARCH_TYPES.HOTEL_LISTING ? (
            <HotelTitleMobile>
              <Typography variant='caption' weight='SemiBold'>
                {`${actionPageLocationLabel} Otelleri`}
              </Typography>
            </HotelTitleMobile>
          ) : (
            <HotelTitleMobile>
              <Typography variant='caption' weight='SemiBold'>
                {actionPageLocationLabel}
              </Typography>
            </HotelTitleMobile>
          )}
        </>
      ) : null}
    </>
  );
};

export default HotelListingTitle;
